import { render, staticRenderFns } from "./AwardsActiveListSection.vue?vue&type=template&id=7e658b24&scoped=true"
import script from "./AwardsActiveListSection.vue?vue&type=script&lang=js"
export * from "./AwardsActiveListSection.vue?vue&type=script&lang=js"
import style0 from "./AwardsActiveListSection.vue?vue&type=style&index=0&id=7e658b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e658b24",
  null
  
)

export default component.exports